<template>
    <section class="skeleton-wrapper">
        <div class="skeleton skeleton-text" v-for="n in 20" :key="n"></div>
    </section>
</template>
<script>
export default {
    name: 'Skeleton',
};
</script>

<style scoped lang="scss">
.skeleton-wrapper {
    padding: 20px;
    max-width: 1180px;
    margin: auto auto 60px;

    .skeleton {
        animation: skeleton-loading 1s linear infinite alternate;
    }

    .skeleton-text {
        width: 100%;
        height: 20px;
        margin: 1rem auto;
        border-radius: 0.25rem;
        padding: 20px;
    }
}

@keyframes skeleton-loading {
    0% {
        background-color: hsl(200, 20%, 80%);
    }
    100% {
        background-color: hsl(200, 20%, 95%);
    }
}
</style>
